import React from 'react';
import './NewCourseCardShimmer.css';

const NewCourseCardShimmer = ({ width, compact }) => {
  return (
    <div
      className={`cr-h-course-card cr-shimmer-card ${compact ? "cr-h-compact" : ""}`}
      style={{ width: width ? width : "100%" }}
    >
      {/* ── Left Media Skeleton (Single Top-Left Badge) ── */}
      <div className="cr-h-media-wrap">
        <div className="cr-shimmer-block w-100 h-100" />
        <div className="cr-h-media-badges">
          <div
            className="cr-shimmer-block"
            style={{ width: "75px", height: "18px", borderRadius: "20px" }}
          />
        </div>
      </div>

      {/* ── Right Content Skeleton ── */}
      <div className="cr-h-content-wrap">
        {/* Top Row Skeleton: Title + Bookmark */}
        <div className="cr-h-top-row mb-1">
          <div className="d-flex flex-column gap-1 flex-grow-1">
            <div
              className="cr-shimmer-block rounded"
              style={{ width: "90%", height: "15px" }}
            />
            <div
              className="cr-shimmer-block rounded"
              style={{ width: "55%", height: "15px" }}
            />
          </div>
          <div
            className="cr-shimmer-block rounded-circle flex-shrink-0"
            style={{ width: "28px", height: "28px" }}
          />
        </div>

        {/* Doctor Info */}
        <div className="d-flex align-items-center gap-2 mb-1">
          <div
            className="cr-shimmer-block rounded-circle"
            style={{ width: "18px", height: "18px", flexShrink: 0 }}
          />
          <div
            className="cr-shimmer-block rounded"
            style={{ width: "85px", height: "11px" }}
          />
          <div
            className="cr-shimmer-block rounded"
            style={{ width: "55px", height: "10px" }}
          />
        </div>

        {/* Description Lines */}
        <div className="d-flex flex-column gap-1 mb-1">
          <div
            className="cr-shimmer-block rounded"
            style={{ width: "100%", height: "10px" }}
          />
          <div
            className="cr-shimmer-block rounded"
            style={{ width: "80%", height: "10px" }}
          />
        </div>

        {/* Feature Chips (2 chips) */}
        <div className="cr-h-chips-row mb-1">
          <div
            className="cr-shimmer-block"
            style={{ width: "70px", height: "18px", borderRadius: "5px" }}
          />
          <div
            className="cr-shimmer-block"
            style={{ width: "75px", height: "18px", borderRadius: "5px" }}
          />
        </div>

        {/* Rating & Reviews Row Skeleton (Directly above footer) */}
        <div className="cr-h-rating-row">
          <div
            className="cr-shimmer-block rounded"
            style={{ width: "95px", height: "13px" }}
          />
          <div
            className="cr-shimmer-block rounded"
            style={{ width: "70px", height: "15px" }}
          />
        </div>

        {/* Price & Action Button */}
        <div className="cr-h-footer-row">
          <div
            className="cr-shimmer-block rounded"
            style={{ width: "65px", height: "20px" }}
          />
          <div
            className="cr-shimmer-block"
            style={{ width: "85px", height: "26px", borderRadius: "20px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(NewCourseCardShimmer);